import { render, staticRenderFns } from "./LanguageInfoForm.vue?vue&type=template&id=50e7e39e"
import script from "./LanguageInfoForm.vue?vue&type=script&lang=js"
export * from "./LanguageInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports